<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active' : detailModal}" id="detail-modal-template" v-if="detailModal">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">{{ getModalTitle() }}</div>
      </div>
      <div class="modal-body-container ht-full">
        <!-- 기본 이력서 수정 내용 -->
        <div v-show="modalState === 'resume'">
          <div class="progress-section mypage-resumeform mt-40">
          <div class="progress-data">
            <div class="progress-text">
              완성도
            </div>
            <div class="progress-bar-container">
              <div class="progress-bar" :style="getProgressWidth(resume.completionRate)"></div>
            </div>
            <div class="percentage">{{ Math.round(resume.completionRate * 100) }}%</div>
          </div>
          <div class="progress-subtext">(높은 이력서 완성도는 더 많은 맞춤형 일자리 추천을 받으실 수 있습니다.)</div>
        </div>
        <div class="mypage-scroll-type tab-container-full full mt-40">
          <div class="tab-head">
            <div class="tab-menu-wrap scroll-tab">
              <button type="button" class="tab-menu" :class="{ 'is-active': selectedTab === 'basic'}" @click="changeTab('basic')">
                기본정보
              </button>
              <button type="button" class="tab-menu" :class="{ 'is-active': selectedTab === 'schools'}" @click="changeTab('schools')">
                학력사항
              </button>
              <button type="button" class="tab-menu" :class="{ 'is-active': selectedTab === 'careers'}" @click="changeTab('careers')">
                경력사항
              </button>
              <button type="button" class="tab-menu" :class="{ 'is-active': selectedTab === 'qualifications'}" @click="changeTab('qualifications')">
                자격증/면허증
              </button>
              <button type="button" class="tab-menu" :class="{ 'is-active': selectedTab === 'oaskills'}" @click="changeTab('oaskills')">
                OA작성능력
              </button>
              <button type="button" class="tab-menu" :class="{ 'is-active': selectedTab === 'activities'}" @click="changeTab('activities')">
                주요활동/사회공헌
              </button>
              <button type="button" class="tab-menu" :class="{ 'is-active': selectedTab === 'preferences'}" @click="changeTab('preferences')">
                희망 활동(근무) 조건
              </button>
              <button type="button" class="tab-menu" :class="{ 'is-active': selectedTab === 'introduction'}" @click="changeTab('introduction')">
                자기소개서
              </button>
            </div>
          </div>
            [저장하기]버튼은 현재 활성화된 탭 메뉴의 내용만 저장됩니다.</br>
            저장하지 않고 탭을 이동할 경우, 기존에 작성하신 내용이 유지되지 않으니 유의해주세요.
          <div class="tab-content__wrap new-type">
            <!-- 기본정보 -->
            <div class="tab-content" :class="{ 'is-active': selectedTab === 'basic'}">
              <basic-modal :basicModal="modals['basic']" ref="basic" :resume="resume" @update:CompletionRate="updateCompletionRate" @update:indbankNo="updateIndbankNo"></basic-modal>
            </div>
            <!-- 학력사항 -->
            <div class="tab-content" :class="{ 'is-active': selectedTab === 'schools'}">
                <schools-modal :schoolsModal="modals['schools']" ref="schools" :indbankNo="resume.indbankNo" :educationLevels="codes.educationLevels" :graduationStatuses="codes.graduationStatuses" :schoolTypes="codes.schoolTypes" @update:CompletionRate="updateCompletionRate"></schools-modal>
            </div>
            <!-- 경력사항 -->
            <div class="tab-content" :class="{ 'is-active': selectedTab === 'careers'}">
                <careers-modal :careersModal="modals['careers']" ref="careers" :indbankNo="resume.indbankNo" @update:CompletionRate="updateCompletionRate"></careers-modal>
            </div>
            <!-- 자격증/면허증 -->
            <div class="tab-content" :class="{ 'is-active': selectedTab === 'qualifications'}">
                <qualifications-modal :qualificationsModal="modals['qualifications']" ref="qualifications" :indbankNo="resume.indbankNo" :passingSteps="codes.passingSteps" @update:CompletionRate="updateCompletionRate"></qualifications-modal>
            </div>
            <!-- OA작성능력  -->
            <div class="tab-content" :class="{ 'is-active': selectedTab === 'oaskills'}">
                <oaskills-modal :oaskillsModal="modals['oaskills']" ref="oaskills" :indbankNo="resume.indbankNo" :oaSkillsCode="codes.oaSkills" @update:CompletionRate="updateCompletionRate"></oaskills-modal>
            </div>
            <!-- 주요활동/사회공헌 -->
            <div class="tab-content" :class="{ 'is-active': selectedTab === 'activities'}">
                <activities-modal :activitiesModal="modals['activities']" ref="activities" :indbankNo="resume.indbankNo" :activitiesCodes="codes.activities" @update:CompletionRate="updateCompletionRate"></activities-modal>
            </div>
            <!-- 희망 활동(근무) 조건 -->
            <div class="tab-content" :class="{ 'is-active': selectedTab === 'preferences'}">
                <preferences-modal :preferencesModal="modals['preferences']" ref="preferences" :district="district" :indbankNo="resume.indbankNo" :codes="codes" @update:CompletionRate="updateCompletionRate"></preferences-modal>
            </div>
            <!-- 자기소개서 -->
            <div class="tab-content" :class="{ 'is-active': selectedTab === 'introduction'}">
                <introduction-modal :introductionModal="modals['introduction']" ref="introduction" :indbankNo="resume.indbankNo" @update:CompletionRate="updateCompletionRate"></introduction-modal>
            </div>
          </div>
        </div>
        <div class="box-type bg-primary mt-40">
          <ul class="list-type-dot">
            <li>
              ‘사업참여 이력’’ 및 ‘교육이수 이력’은 이력서에 자동으로 첨부됩니다.
              <div class="butotn-area flex gap10 mt-8">
                <button type="button" class="btn btn-line-box btn-sm" @click="showJobActHistories">사업참여이력</button>
                <button type="button" class="btn btn-line-box btn-sm" @click="showEducationHistories">교육이수이력</button>
              </div>
            </li>
          </ul>
        </div>
        </div>

        <!-- 교육이수 이력 -->
        <div v-show="modalState === 'education'" key="education-modal">
          <education-histories-modal
            v-if="modalState === 'education'"
            :educationHistoriesModal="true"
            :indbankNo="resume.indbankNo"
            :autoLoad="true"
            @error="handleHistoryError"
            ref="educationHistoriesModal"
          />
        </div>

        <!-- 사업참여 이력 -->
        <div v-show="modalState === 'jobact'" key="jobact-modal">
          <job-act-histories-modal
            v-if="modalState === 'jobact'"
            :jobActHistoriesModal="true"
            :indbankNo="resume.indbankNo"
            :autoLoad="true"
            @error="handleHistoryError"
            ref="jobActHistoriesModal"
          />
        </div>
      </div>
      <div class="modal-footer" v-if="modalState === 'resume'">
        <button type="button" class="btn btn-secondary btn-md button-wid150" @click="close">
          취소하기
        </button>
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="save">
          저장하기
        </button>
      </div>
      <div class="modal-footer" v-else>
        <button type="button" class="btn btn-secondary btn-md button-wid150" @click="backToResumeModal">
          닫기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>
<script>
import Axios from 'axios';
import BasicModal from './Basic.vue';
import SchoolsModal from './Schools.vue';
import CareersModal from './Careers.vue';
import QualificationsModal from './Qualifications.vue';
import OaskillsModal from './Oaskills.vue';
import ActivitiesModal from './Activities.vue';
import PreferencesModal from './Preferences.vue';
import IntroductionModal from './Introduction.vue';
import EducationHistoriesModal from './EducationHistories.vue';
import JobActHistoriesModal from './JobActHistories.vue';

export default {
  name: 'detail-modal-template',
  props: {
    detailModal: {
      type: Boolean,
      default: false,
    },
    resume: {
      type: Object,
      default: () => ({ }),
    },
    adminMode: {
      type: Boolean,
      default: false,
    },
    memberName: {
      type: String,
      default: '',
    },
    district: {
      type: String,
      default: '',
    },
  },
  components: {
    BasicModal,
    SchoolsModal,
    CareersModal,
    QualificationsModal,
    OaskillsModal,
    ActivitiesModal,
    PreferencesModal,
    IntroductionModal,
    EducationHistoriesModal,
    JobActHistoriesModal,
  },
  data() {
    return {
      selectedTab: 'basic',
      modalState: 'resume', // 'resume' | 'education' | 'jobact'
      modals: {
        basic: true,
        schools: false,
        careers: false,
        qualifications: false,
        oaskills: false,
        activities: false,
        preferences: false,
        introduction: false,
      },
      codes: {
        activities: [],
        desiredEmploymentTypeCodes: [],
        desiredOccupationCodes: [],
        desiredSalaryRanges: [],
        desiredWorkRegions: [],
        educationLevels: [],
        graduationStatuses: [],
        schoolTypes: [],
        oaSkills: [],
        passingSteps: [],
      },
    };
  },
  watch: {
    detailModal(newVal) {
      if (newVal) {
        this.selectedTab = 'basic';
        this.$nextTick(() => {
          this.scrollActiveTabIntoView();
        });
      }
    },
    selectedTab(newVal, oldVal) {
      this.modals[oldVal] = false;
      this.modals[newVal] = true;
    },
  },
  methods: {
    close() {
      // 모달 상태 초기화
      this.modalState = 'resume';

      // 관리자 모드와 일반 회원 모드를 구분하여 처리
      if (this.adminMode) {
        // 관리자 페이지: 기존 ESC 키 이벤트 방식 사용
        const escEvent = new KeyboardEvent('keydown', {
          key: 'Escape',
          code: 'Escape',
          keyCode: 27,
          which: 27,
          bubbles: true,
          cancelable: true,
        });
        document.dispatchEvent(escEvent);
      } else {
        // 일반 회원 페이지: Vue 표준 emit 방식 사용
        $('body').removeClass('modal-open');
        this.$emit('closeDetailviewModal');
      }
    },

    /**
     * 교육이수 이력 팝업으로 전환
     */
    showEducationHistories() {
      this.safeModalTransition('education');
    },

    /**
     * 사업참여 이력 팝업으로 전환
     */
    showJobActHistories() {
      this.safeModalTransition('jobact');
    },

    /**
     * 안전한 모달 전환 처리
     */
    safeModalTransition(newState) {
      // 이미 해당 상태면 중복 처리 방지
      if (this.modalState === newState) {
        return;
      }

      // 이전 컴포넌트 정리 (안전한 방식으로)
      this.cleanupPreviousComponent();

      // 상태 변경은 $nextTick으로 지연하여 안전하게 처리
      this.$nextTick(() => {
        this.modalState = newState;
      });
    },

    /**
     * 이전 컴포넌트 안전 정리
     */
    cleanupPreviousComponent() {
      if (this.$refs.educationHistoriesModal) {
        delete this.$refs.educationHistoriesModal;
      }

      if (this.$refs.jobActHistoriesModal) {
        delete this.$refs.jobActHistoriesModal;
      }
    },

    /**
     * 이력서 수정 팝업으로 복귀
     */
    backToResumeModal() {
      this.safeModalTransition('resume');
    },

    /**
     * 모달 상태에 따른 제목 반환
     */
    getModalTitle() {
      switch (this.modalState) {
        case 'education':
          return '교육이수 내역';
        case 'jobact':
          return '사업참여 이력';
        default:
          return '이력서 작성하기';
      }
    },

    /**
     * 이력 컴포넌트 에러 핸들링
     */
    handleHistoryError(errorInfo) {
      this.showUserFriendlyError(errorInfo);
    },

    /**
     * 사용자 친화적 에러 메시지 표시
     */
    showUserFriendlyError() {
      const errorMessage = '데이터를 불러오는 중 문제가 발생했습니다.\n잠시 후 다시 시도해주세요.\n\n문제가 지속되면 고객센터(02-460-5050)로 연락 부탁드립니다.';

      alert(errorMessage);
    },
    getProgressWidth(rate) {
      const progressWidth = rate * 100;
      return { width: `${progressWidth}%` };
    },
    save() {
      switch (this.selectedTab) {
        case 'basic':
          this.$refs.basic.updateBasic();
          break;
        case 'schools':
          this.$refs.schools.updateSchools();
          break;
        case 'careers':
          this.$refs.careers.updateCareers();
          break;
        case 'qualifications':
          this.$refs.qualifications.updateQualifications();
          break;
        case 'oaskills':
          this.$refs.oaskills.updateOaskills();
          break;
        case 'activities':
          this.$refs.activities.updateActivities();
          break;
        case 'preferences':
          this.$refs.preferences.updatePreferences();
          break;
        case 'introduction':
          this.$refs.introduction.updateIntroduction();
          break;
        default:
          break;
      }
    },
    changeTab(kind) {
      if (!this.resume.indbankNo) {
        alert('기본정보 탭 내용을 먼저 저장해주세요.');
        return;
      }
      this.selectedTab = kind;
      this.scrollActiveTabIntoView();
    },
    scrollActiveTabIntoView() {
      const container = document.querySelector('.tab-container-full');
      if (!container) return;

      const tabMenuWrap = container.querySelector('.scroll-tab');
      const activeTab = container.querySelector('.tab-menu.is-active');

      if (activeTab && tabMenuWrap && tabMenuWrap.scrollWidth > tabMenuWrap.clientWidth) {
        activeTab.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    },
    getResumeCodes() {
      const endpoint = '/api/common-codes/resume-codes';

      Axios.get(endpoint).then((response) => {
        this.codes = response.data;
      }).catch((e) => {
        const errorMessage = (e.response && e.response.data && e.response.data.message) || '공통 코드 조회 중 오류가 발생했습니다.';
        alert(errorMessage);
      });
    },

    // 관리자 모드 감지 헬퍼 메서드
    getApiBasePath() {
      return this.adminMode ? '/admin/api' : '/api';
    },

    /**
     * 완성도 업데이트 핸들러
     */
    updateCompletionRate(newRate) {
      this.resume.completionRate = newRate;
      this.$emit('update:resumeList');
    },
    updateIndbankNo(newIndbankNo) {
      this.resume.indbankNo = newIndbankNo;
    },
  },
  mounted() {
    this.getResumeCodes();
  },

  beforeDestroy() {
    // 모든 타이머나 비동기 작업 정리
    if (this.modalTransitionTimeout) {
      clearTimeout(this.modalTransitionTimeout);
      this.modalTransitionTimeout = null;
    }

    // 안전한 컴포넌트 참조 정리
    if (this.$refs) {
      Object.keys(this.$refs).forEach((key) => {
        delete this.$refs[key];
      });
    }

    // 모달 상태 초기화
    this.modalState = 'resume';
  },
};
</script>



// WEBPACK FOOTER //
// Detail.vue?ef59763a